import { initialListPaginationMeta } from "utils/helpers/pagination";

import { ManufacturerForm, ManufacturerState } from "../types";

export const initialManufacturerForm: ManufacturerForm = {
  menufecturerName: "",
};

export const initialState: ManufacturerState = {
  loading: false,
  reordering: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  error: null,
  form: initialManufacturerForm,
  isAddModalOpen: false,
  selectedId: 0,
};
